export default {
  props: {
    called_by: String,
  },
  data() {
    return {
      selectedList: [],
      filter: {
        externalid: "",
        veinsId: "",
        firstname: "",
        lastname: "",
        phone: "",
        Dob: "",
        sdate: "",
        startDate: "",
        endDate: "",
        Status: "",
        refreshData: false,
      },
      statusList: [
        {
          id: 1,
          name: 'Sent', 
        },
        {
          id: 2,
          name: 'Pending', 
        },
        {
          id: 3,
          name: 'Disputed', 
        },
        {
          id: 4,
          name: 'Paid', 
        },
        {
          id: 5,
          name: 'Refund',
        },
        {
          id: 6,
          name: 'PartiallyRefunded',
        },
        {
          id: 7,
          name: 'PartiallyPaid', 
        },
        // {
        //   id: 8,
        //   name: 'Deleted'
        // },
        {
          id: 9,
          name: 'Reconciled'
        }
      ],
      currentDateRange: "",
      sdate: null,
      dateMenu: [
        {
          label: "Today",
          command: () => {
            this.setDateLastXDays(0);
          },
        },
        {
          label: "Yesterday",
          command: () => {
            this.setDateLastXDays(1);
          },
        },
        {
          label: "Last 7 Days",
          command: () => {
            this.setDateLastXDays(7);
          },
        },
        {
          label: "Last 30 Days",
          command: () => {
            this.setDateLastXDays(30);
          },
        },
        {
          label: "This Month",
          command: () => {
            this.setDateThisMonth();
          },
        },
        {
          label: "Last Month",
          command: () => {
            this.setDateLastMonth();
          },
        },
        {
          label: "Uptil Now",
          command: () => {
            this.setDateUptilNow();
          },
        },
      ],
    }; // data - return
  }, // data
  mounted() {
    if (this.called_by === "PatientPortal") {
      this.setDateUptilNow();
    } else if (this.called_by === "VeinCheckInModal") 
      this.setDateUptilNow();
      else if (this.called_by === "CheckOutModal")
       this.setDateUptilNow();
      else if(this.called_by === "PaymentRequest")
       this.setDateUptilNow();
      else if(this.called_by === "PaymentRequest_1")
       this.setDateUptilNow();
      else this.setDateLastXDays(0);

    this.applyDateClick();
    console.log("call-back ", this.$store.state.filterSTGDSP);
  }, //--mounted
  methods: {
    applyDateClick() {
      if(this.called_by === 'VeinCheckInModal'|| this.called_by === 'PatientPortal'){
      const str = this.filter.Dob;
      const arr = str.split('-');
      let three = arr[0].slice(0, 3);
      let two = arr[0].slice(0, 2);
      let one = arr[0].slice(0, 1);
        if(three === "000" || two === "00" || one === "0"){
        return;
       }
      }
    
      const darr = this.currentDateRange.split(" to ");
      let startDate = "";
      let endDate = "";

      if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
      else startDate = new Date(darr[0]);
      endDate = new Date(darr[1]);

      this.filter.startDate =  this.dateToYMD(startDate);
      this.filter.endDate =  this.dateToYMD(endDate);
      this.filter.refreshData = false;
      
      //set status value
       if (this.selectedList.length > 0) {
          let aa = [];
        for (let i = 0; i < this.selectedList.length; i++)
         aa.push(this.selectedList[i].id);
         this.filter.Status = aa.toString();
      } else{
        this.filter.Status = "";
      }

      this.$store.dispatch("setFilterSTGDSP_ACT", this.filter);
      console.log("call-back ", this.$store.state.filterSTGDSP);
      this.$emit("apply-search-click");
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    applySearchClick() {
     //debugger
      this.filter.refreshData = true;
      //console.log("call-back ", this.$store.state.filterSTGDSP);
      this.$emit("apply-search-click");
    },
    clearSearchFields() {
      this.externalid = "";
      this.veinsId = "";
      this.firstname = "";
      this.lastname = "";
      this.phone = "";
      this.sdate = "";
      this.currentDateRange = "";
      this.setDateLastXDays(0);
    },
    setDateLastXDays(days) {
      let startdate = new Date(new Date().setDate(new Date().getDate() - days));
      let enddate = new Date();
      if (days == 1) enddate = startdate;

      const options = { year: "numeric", month: "short", day: "numeric" };
      this.currentDateRange =
        startdate.toLocaleDateString(undefined, options) +
        " to " +
        enddate.toLocaleDateString(undefined, options);
    },
    setDateThisMonth() {
      const date = new Date();
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let str = "";
      const options = { year: "numeric", month: "short", day: "numeric" };
      this.currentDateRange =
        firstDay.toLocaleDateString(undefined, options) +
        " to " +
        date.toLocaleDateString(undefined, options);
    },
    setDateLastMonth() {
      const date = new Date();
      const prevMonthLastDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        0
      );
      var prevMonthFirstDate = new Date(
        date.getFullYear() - (date.getMonth() > 0 ? 0 : 1),
        (date.getMonth() - 1 + 12) % 12,
        1
      );
      let str = "";
      const options = { year: "numeric", month: "short", day: "numeric" };
      this.currentDateRange =
        prevMonthFirstDate.toLocaleDateString(undefined, options) +
        " to " +
        prevMonthLastDate.toLocaleDateString(undefined, options);
    },
     isSpecialSymbol(evt) {
      //console.log("this a pressing");
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode == 43 || charCode == 47 || charCode == 39 || charCode == 59 || charCode == 61
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setDateUptilNow() {
      const date = new Date();
      let str = "";
      const options = { year: "numeric", month: "short", day: "numeric" };
      this.currentDateRange =
        "From start to " + date.toLocaleDateString(undefined, options);
    },
  },
   watch: {
    sdate: function () {
      try {debugger;
        const startdate = new Date(this.sdate[0]); 
        console.log("Start", startdate);
        const enddate = new Date(this.sdate[1]);
        console.log("end", enddate);
      
        const options = { year: "numeric", month: "short", day: "numeric" };
        this.currentDateRange =
          startdate.toLocaleDateString(undefined, options) +
          " to " +
          enddate.toLocaleDateString(undefined, options);
          console.log(this.currentDateRange);
      } catch {
        /**/
      }
    },
  },
};